import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $, nothing as w } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import { state as t } from '../../../../node_modules/@lit/reactive-element/decorators/state.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { getRandomNumber } from '../../utilities/math/index.js';
import '../../atoms/buttons/enums.js';
import { isRTL } from '../../utilities/dom-helpers/index.js';
import { AlignmentTypes } from '../image-block/types.js';
import '../../molecules/lightbox/index.js';
import { StyleTypes } from '../text-block/types.js';
import { VideoTypes } from '../../molecules/video-player/types.js';
import img from './assets/skip_previous.svg.js';
import img$1 from './assets/skip_next.svg.js';
import css_248z from './video-block.scss.js';

class VideoBlock extends s {
    constructor() {
        super(...arguments);
        this.closeButtonText = 'Close';
        this.styleType = StyleTypes.GREY;
        this.buttonAriaLabel = 'Play video';
        this.autoplay = false;
        this.insideTitle = true;
        this.layout = 'right';
        this.visibleButtons = false;
        this.forceAspectRatio = false;
        this.componentType = '';
        this.thumbnailIsVisible = true;
        this.insideTextBlock = false;
        this.insideVideoGallery = false;
        this.forceAlignmentNone = false;
        this._videoPlayer = this.querySelector('video-player');
        this._id = null;
    }
    showLightbox() {
        this.shadowRoot.querySelector('light-box').setAttribute('show', 'true');
    }
    runVideo() {
        var _a, _b, _c, _d;
        if (((_a = this._videoPlayer) === null || _a === void 0 ? void 0 : _a.type) === VideoTypes.LOCAL) {
            if (this.thumbnailIsVisible) {
                (_c = (_b = this._videoPlayer.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector('video')) === null || _c === void 0 ? void 0 : _c.play();
            }
        }
        else if (this._videoPlayer) {
            this._videoPlayer.autoplay = true;
        }
        // DCCC-8359: YouTube players are no longer initialised on page load —
        // the user pressing play is what triggers loading the (nocookie) player.
        const player = this.querySelector('video-player, video-player-plus');
        (_d = player === null || player === void 0 ? void 0 : player.initAndPlay) === null || _d === void 0 ? void 0 : _d.call(player);
    }
    showInlineVideo() {
        var _a;
        this.thumbnailIsVisible = false;
        if (this._videoPlayer)
            this.removeTabIndex();
        (_a = this.shadowRoot.querySelector('.video-block')) === null || _a === void 0 ? void 0 : _a.classList.remove('gradient');
    }
    removeTabIndex() {
        this._videoPlayer.removeAttribute('tabindex');
    }
    addTabIndex() {
        this._videoPlayer.setAttribute('tabindex', '-1');
    }
    handleThumbnailClick() {
        var _a, _b;
        if (this.componentType === 'multicomponent' && this._videoPlayer) {
            const videoType = this._videoPlayer.type;
            const videoReference = this._videoPlayer.videoId;
            let videoUrl = null;
            if (videoType === VideoTypes.YOUTUBE) {
                videoUrl = `https://www.youtube.com/watch?v=${videoReference}`;
            }
            else if (videoType === VideoTypes.VIMEO) {
                videoUrl = `https://vimeo.com/${videoReference}`;
            }
            else if (videoType === VideoTypes.LOCAL) {
                videoUrl = videoReference;
            }
            if (videoUrl) {
                window.open(videoUrl, '_blank');
                return;
            }
        }
        this.runVideo();
        this.showInlineVideo();
        const player = (_a = this.renderRoot
            .querySelector('slot[name="inline-video"]')) === null || _a === void 0 ? void 0 : _a.assignedElements({ flatten: true })[0];
        if (this.alignment === AlignmentTypes.NONE &&
            this.componentType === 'multicomponent' &&
            player) {
            player.style.minHeight = '300px';
            player.style.display = 'block';
        }
        if (player instanceof s) {
            const video = (_b = player.renderRoot) === null || _b === void 0 ? void 0 : _b.querySelector('video');
            video === null || video === void 0 ? void 0 : video.focus();
        }
    }
    firstUpdated() {
        this._id = `box-${getRandomNumber().toString(16).slice(2)}`;
        const parent = this.parentNode;
        const img = this.querySelector('img');
        if ((parent === null || parent === void 0 ? void 0 : parent.tagName.toLowerCase()) === 'text-block')
            this.insideTextBlock = true;
        if (parent === null || parent === void 0 ? void 0 : parent.classList.contains('gallery-container-videos'))
            this.insideVideoGallery = true;
        if (this.insideTextBlock)
            img === null || img === void 0 ? void 0 : img.classList.add('insideTextBlock');
        if (this._videoPlayer)
            this.addTabIndex();
        this.addEventListener('lightbox-closed', () => {
            var _a, _b;
            this.thumbnailIsVisible = true;
            const video = (_b = (_a = this._videoPlayer) === null || _a === void 0 ? void 0 : _a.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector('video');
            if (video) {
                video.pause();
                video.currentTime = 0;
            }
        });
        this.applySlotStyles();
    }
    updated(changedProperties) {
        super.updated(changedProperties);
        if (this.componentType === 'multicomponent' &&
            (this.alignment === AlignmentTypes.CENTER ||
                this.alignment === AlignmentTypes.FULL_WIDTH)) {
            this.setAttribute('alignment', 'none');
            this.forceAlignmentNone = true;
        }
        else if (this.forceAlignmentNone) {
            this.setAttribute('alignment', this.alignment);
            this.forceAlignmentNone = false;
        }
        if (changedProperties.has('insideTitle')) {
            this.applySlotStyles();
        }
    }
    applySlotStyles() {
        var _a, _b;
        const textSlot = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('slot[name="text"]');
        const captionSlot = (_b = this.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector('slot[name="caption"]');
        if (!textSlot || !captionSlot)
            return;
        const textNodes = textSlot.assignedNodes({ flatten: true }) || [];
        const captionNodes = captionSlot.assignedNodes({ flatten: true }) || [];
        textNodes.forEach(node => {
            if (node.nodeType === Node.ELEMENT_NODE) {
                const element = node;
                element.style.color = !this.insideTitle ? '#512573' : '';
                element.style.fontFamily = '"Noto Sans"';
                element.style.fontSize = '20px';
                element.style.fontStyle = 'normal';
                element.style.fontWeight = '700';
                element.style.lineHeight = '30px';
                element.style.margin = '0';
                element.style.textAlign = 'left';
            }
        });
        captionNodes.forEach(node => {
            if (node.nodeType === Node.ELEMENT_NODE) {
                const element = node;
                element.style.color = getComputedStyle(this).getPropertyValue('--caption-text-color').trim() || '#333';
                element.style.fontFamily = 'Noto Sans';
                element.style.fontSize = '16px';
                element.style.fontStyle = 'normal';
                element.style.fontWeight = '400';
                element.style.lineHeight = '24px';
                element.style.margin = '0';
                element.style.textAlign = getComputedStyle(this).getPropertyValue('--caption-text-align').trim() || 'left';
            }
        });
    }
    renderLightBox(isFullWidth, isNoneAlignment) {
        if (!isFullWidth && !isNoneAlignment) {
            return $ `<light-box id="${this._id}" closeButtonText="${this.closeButtonText}"><div slot="content"><slot name="lightbox-video"></slot></div></light-box>`;
        }
        return null;
    }
    render() {
        const { alignment, componentType } = this;
        const shouldBehaveAsCenter = alignment === AlignmentTypes.NONE && componentType === 'multicomponent';
        const styleClass = `style-${this.styleType}`;
        const isFullWidth = alignment === AlignmentTypes.FULL_WIDTH;
        const isNoneAlignment = alignment === AlignmentTypes.NONE && !shouldBehaveAsCenter;
        const lightbox = this.renderLightBox(isFullWidth, isNoneAlignment);
        return $ `<div class="video-text-container ${this.layout} ${this.componentType === 'multicomponent'
            ? 'full-video-multicomponent'
            : ''} ${this.forceAspectRatio ? 'force-aspect-ratio' : ''}"><div class="video-container"><div class="video-block gradient ${this.alignment} ${this.rtl || isRTL()
            ? 'rtl'
            : ''} ${this.insideTextBlock ? 'insideTextBlock' : ''} ${this
            .insideVideoGallery
            ? 'insideVideoGallery'
            : ''}"><button type="button" aria-label="${this.insideTitle ? w : this.buttonAriaLabel}" data-target="${this._id}" class="thumbnail ${!this.thumbnailIsVisible
            ? 'hide'
            : ''} ${styleClass}" @click="${() => {
            if (isFullWidth ||
                isNoneAlignment ||
                this.componentType === 'multicomponent') {
                this.handleThumbnailClick();
            }
            else {
                this.showLightbox();
            }
        }}"><slot name="thumbnail"></slot><div class="video-controls"><div class="play"><svg class="play-icon" width="50" height="64" viewBox="0 0 50 64" fill="none" xmlns="http://www.w3.org/2000/svg"><defs><linearGradient id="icon-gradient" x1="3" y1="3" x2="11.3747" y2="65.7543" gradientUnits="userSpaceOnUse"><stop stop-color="#6F2595"/><stop offset="1" stop-color="#AA0061"/></linearGradient></defs><path d="M47 32L48.6509 29.4951C49.4931 30.0502 50 30.9913 50 32C50 33.0087 49.4931 33.9498 48.6509 34.5049L47 32ZM4.65094 63.5049C3.26753 64.4167 1.40691 64.0343 0.495124 62.6509C-0.416665 61.2675 -0.0343452 59.4069 1.34906 58.4951L4.65094 63.5049ZM3 3L1.19209e-06 3C1.47875e-06 1.89645 0.605871 0.88199 1.57747 0.35871C2.54907 -0.164569 3.72952 -0.112175 4.65094 0.495125L3 3ZM6 32L6 35L-1.39876e-06 35L-1.26763e-06 32L6 32ZM48.6509 34.5049L4.65094 63.5049L1.34906 58.4951L45.3491 29.4951L48.6509 34.5049ZM45.3491 34.5049L1.34906 5.50487L4.65094 0.495125L48.6509 29.4951L45.3491 34.5049ZM6 3L6 32L-1.26763e-06 32L1.19209e-06 3L6 3Z" fill="none"/></svg></div>${this.insideTitle ? $ `<slot name="text"></slot>` : ''}</div><slot name="description"></slot><slot name="inline-video"></slot></button> ${lightbox}</div></div><div class="text-container"><slot name="text"></slot><slot name="caption"></slot>${this.visibleButtons
            ? $ `<div class="button-container"><button class="nav-button prev"><img src="${img}" alt="Previous"> <span>Previous</span></button> <button class="nav-button next"><span>Next</span> <img src="${img$1}" alt="Next"></button></div>`
            : ''}</div></div>`;
    }
}
VideoBlock.styles = css_248z;
__decorate([
    e({ type: String })
], VideoBlock.prototype, "alignment", void 0);
__decorate([
    e({ type: Boolean })
], VideoBlock.prototype, "rtl", void 0);
__decorate([
    e()
], VideoBlock.prototype, "closeButtonText", void 0);
__decorate([
    e({ type: String })
], VideoBlock.prototype, "styleType", void 0);
__decorate([
    e({ type: String })
], VideoBlock.prototype, "buttonAriaLabel", void 0);
__decorate([
    e({ type: Boolean })
], VideoBlock.prototype, "autoplay", void 0);
__decorate([
    e({ type: Boolean, reflect: true })
], VideoBlock.prototype, "insideTitle", void 0);
__decorate([
    e({ type: String, reflect: true })
], VideoBlock.prototype, "layout", void 0);
__decorate([
    e({ type: Boolean })
], VideoBlock.prototype, "visibleButtons", void 0);
__decorate([
    e({ type: Boolean })
], VideoBlock.prototype, "forceAspectRatio", void 0);
__decorate([
    e({ type: String })
], VideoBlock.prototype, "componentType", void 0);
__decorate([
    t()
], VideoBlock.prototype, "thumbnailIsVisible", void 0);
__decorate([
    t()
], VideoBlock.prototype, "insideTextBlock", void 0);
__decorate([
    t()
], VideoBlock.prototype, "insideVideoGallery", void 0);
__decorate([
    t()
], VideoBlock.prototype, "forceAlignmentNone", void 0);
customElements.define('video-block', VideoBlock);

export { VideoBlock };
